import {
  GET_USER,
  GET_USERS_BY_IDS,
  SUGGEST_USERS,
  GET_USER_SYSTEMS,
  GET_USER_PREFERENCES,
  UPDATE_USER_PREFERENCES,
  SET_ACTIVE_USER,
  UPDATE_ACTIVE_USER,
  GET_DIRECT_REPORTS,
  GET_DIRECT_REPORTS_WITH_TIME,
  GET_DIRECT_REPORTS_WITH_TIME_SUCCESS,
  GET_DIRECT_REPORTS_WITH_TIME_ERROR,
  RESET_DIRECT_REPORTS_WITH_TIME,
} from './types';
import { getFetchHeaders } from '../getFetchHeaders';
import { getFetchResponseData } from '../getFetchResponseData';
import { createFetchActions } from '../createFetchActions';

export const actionCreators = {
  setActiveUser: (userData) => {
    return {
      type: SET_ACTIVE_USER,
      data: userData,
    };
  },
  updateActiveUser: (oid) => ({
    type: UPDATE_ACTIVE_USER,
    oid,
  }),
  getUser: (id) =>
    createFetchActions({
      url: `/api/user/${id}`,
      startAction: GET_USER,
    }),
  getUsersByIds: (userIds) =>
    createFetchActions({
      url: '/api/user/ids',
      method: 'POST',
      startAction: GET_USERS_BY_IDS,
      body: { ids: userIds },
    }),
  getDirectReports: (id, pageNumber = 1) =>
    createFetchActions({
      url: `/api/user/${id}/directReports?pageNumber=${pageNumber}`,
      startAction: GET_DIRECT_REPORTS,
    }),
  suggestUsers: (query, id) =>
    createFetchActions({
      url:
        query == null
          ? `/api/user/suggest?id=${id}`
          : `/api/user/suggest?q=${query}`,
      startAction: SUGGEST_USERS,
    }),
  suggestDirectReports: (query, id) =>
    createFetchActions({
      url:
        query == null
          ? `/api/user/suggest/directReports?id=${id}`
          : `api/user/suggest/directReports?q=${query}&id=${id}`,
      startAction: SUGGEST_USERS,
    }),
  getSystemsForUser: () =>
    createFetchActions({
      startAction: GET_USER_SYSTEMS,
      url: '/api/user/systems',
    }),
  getUserPreferences: () =>
    createFetchActions({
      startAction: GET_USER_PREFERENCES,
      url: '/api/user/preferences',
    }),
  updateUserPreferences: (preferences) =>
    createFetchActions({
      method: 'POST',
      body: preferences,
      startAction: UPDATE_USER_PREFERENCES,
      url: '/api/user/preferences',
    }),
  getDirectReportsWithTimes: (id, startDate, endDate) => {
    return async (dispatch) => {
      dispatch({ type: GET_DIRECT_REPORTS_WITH_TIME, id });
      var headers = await getFetchHeaders();
      var endpointUrl = `/api/v2/timetracker/directReports/${id}/${startDate}/${endDate}`;
      return fetch(endpointUrl, {
        method: 'GET',
        headers: headers,
      })
        ?.then(async (response) => {
          return await getFetchResponseData(response);
        })
        ?.then((results) => {
          dispatch({
            type: GET_DIRECT_REPORTS_WITH_TIME_SUCCESS,
            id,
            results,
          });
        })
        ?.catch((err) => {
          dispatch({ type: GET_DIRECT_REPORTS_WITH_TIME_ERROR, id });
          return Promise.reject(err);
        });
    };
  },
  resetDirectReportsWithTimes: () => ({ type: RESET_DIRECT_REPORTS_WITH_TIME }),
};
